import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Toolbar from '@material-ui/core/Toolbar';
import { useTheme, makeStyles } from '@material-ui/core/styles';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import Typography from '@material-ui/core/Typography';
import React, { useMemo, useState } from 'react';
import { useQuery } from 'react-query';
import usePortalAuth from '../../../../auth/usePortalAuth';

import { postApiData, fetchApiData } from '../../../../utils/service';
import { LoadingSpinner } from '../../LoadingSpinner/LoadingSpinner';
import AssignTrainingTable from './AssignTrainingTable';
import basePCUrl from '../../../../Globals';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

//const getUserAPI = 'https://portalapidev.phishcloud.io/api/UserManagement/SearchUserByEmail';


export default function AssignTraining(props) {
  const theme = useTheme();
  const [selectedCourseIds, setSelectedCourseIds] = useState([]);
  const [tablePage, setTablePage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [personName, setPersonName] = React.useState([]);
  const { getAccessTokenSilently } = usePortalAuth();
  const [open, setOpen] = React.useState(false);
  const [openPopup, setOpenPopup] = React.useState(false);
  const [value, setValue] = React.useState('view-training');
  const [selectedUser, setSelectedUser] = React.useState({
    assignees: [],
    courseList: [],
  });

  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  var getByEmail = {
    email: '@',
  };
  const assignCourse = useQuery(
    'assign-course',
    async () => {
      const token = await getAccessTokenSilently();
      return postApiData(basePCUrl, token, selectedUser, 'setUserTraining');
    },
    {
      enabled: false,
    }
  );
  const { isLoading, data, isError, error, refetch } = useQuery(
    'getUserList',
    async () => {

      const token = await getAccessTokenSilently();
      return fetchApiData(basePCUrl, token, 'getUserList', props.accessLevel, props.selectedClient );


    },
    {
      enabled: false,
    }
  );


  const handleClosePopup = () => {
    setOpenPopup(false);
  };

  const handleChangeRadio = (event) => {
    const {
      target: { value },
    } = event;
    if (value === 'assign-all') {
      let userList = data?.users.map(({ email }) => email);
      setSelectedUser({ ...selectedUser, assignees: userList });
    }
    value === 'select-user' && setSelectedUser({ ...selectedUser, assignees: [] });
    setValue(event.target.value);
    console.log(event.target.value);
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    // On autofill we get a stringified value.
    const userData = typeof value === 'string' ? value.split(',') : value;

    setPersonName(userData);
    setSelectedUser({ ...selectedUser, assignees: userData });
  };

  const courseList = props.courseList || [];

  const selectedCourses = useMemo(
    () => courseList.filter((course) => selectedCourseIds.includes(course.modId)),
    [courseList, selectedCourseIds]
  );

  const allVisibleSelected =
    courseList.length > 0 && selectedCourseIds.length === courseList.length;

  const handleToggleCourse = (modId) => {
    setSelectedCourseIds((prev) =>
      prev.includes(modId) ? prev.filter((id) => id !== modId) : [...prev, modId]
    );
  };

  const handleToggleAll = () => {
    if (allVisibleSelected) {
      setSelectedCourseIds([]);
      return;
    }
    setSelectedCourseIds(courseList.map((course) => course.modId).filter(Boolean));
  };

  const handleClickOpen = () => {
    const nextCourseList = selectedCourses.map((course) => ({
      trainingModule: course.modId,
      courseDesignation: 'required',
      completionDate: '2022-04-01',
    }));

    setSelectedUser({ ...selectedUser, courseList: nextCourseList });
    refetch();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedUser({
      assignees: [],
      courseList: [],
    });
    setSelectedCourseIds([]);
  };

  const handleAssignCourse = () => {
    assignCourse.refetch();
    setOpenPopup(true);
    setSelectedCourseIds([]);
    setSelectedUser({
      assignees: [],
      courseList: [],
    });
    setOpen(false);
  };

  if (isLoading || assignCourse.isLoading) {
    return <LoadingSpinner className="LinkTableSpinner" box="LinkTableSpinnerBox" />;
  }

  if (isError) {
    return <h2>{error.message}</h2>;
  }

  const checkBoxTheme = createMuiTheme({
    palette: {
      primary: {
        main: '#428BC9',
      },
      secondary: {
        main: '#428BC9',
      },
    },

  });


  return (
    <div className="traininig-suite-container">
      <MuiThemeProvider theme={checkBoxTheme}>
        <Paper style={{ padding: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, gap: 12, flexWrap: 'wrap' }}>
            <Typography variant="h6">{`Training Courses (${courseList.length})`}</Typography>
            <Button
              variant="contained"
              color="primary"
              disabled={selectedCourses.length === 0}
              onClick={handleClickOpen}
            >
              {getTranslation('Assign Selected Courses', preferredLanguage)}
            </Button>
          </div>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      color="primary"
                      indeterminate={selectedCourseIds.length > 0 && !allVisibleSelected}
                      checked={allVisibleSelected}
                      onChange={handleToggleAll}
                      inputProps={{ 'aria-label': 'select all courses' }}
                    />
                  </TableCell>
                  <TableCell>Course Name</TableCell>
                  <TableCell align="center">Estimated Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {courseList
                  .slice(tablePage * rowsPerPage, tablePage * rowsPerPage + rowsPerPage)
                  .map((course) => {
                    const checked = selectedCourseIds.includes(course.modId);
                    return (
                      <TableRow key={course.modId || course.title} hover selected={checked}>
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={checked}
                            onChange={() => handleToggleCourse(course.modId)}
                          />
                        </TableCell>
                        <TableCell>{course.title}</TableCell>
                        <TableCell align="center">
                          {(Math.floor(course.timeEstimate / 60) || 0) + ' minutes'}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {courseList.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={3} align="center">
                      No courses available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={courseList.length}
            page={tablePage}
            onPageChange={(_, next) => setTablePage(next)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(e) => {
              setRowsPerPage(parseInt(e.target.value, 10));
              setTablePage(0);
            }}
            rowsPerPageOptions={[5, 10, 25, 50]}
          />
        </Paper>
      </MuiThemeProvider>
      <div>
        <Dialog disableEscapeKeyDown open={open} onClose={handleClose}>
          <DialogTitle>{getTranslation("Select User to Assign Course", preferredLanguage)}</DialogTitle>
          <DialogContent>
            {
              <FormControl component="fieldset">
                <RadioGroup row aria-label="position" name="position" value={value} onChange={handleChangeRadio}>
                  <FormControlLabel
                    value="assign-all"
                    control={<Radio color="primary" />}
                    label={getTranslation("Assign all", preferredLanguage)}
                    labelPlacement="start"
                  />
                  <FormControlLabel
                    value="select-user"
                    control={<Radio color="primary" />}
                    label={getTranslation("Select User", preferredLanguage)}
                    labelPlacement="start"
                  />
                </RadioGroup>
              </FormControl>
            }
            {value === 'select-user' && (
              <div>
                <FormControl style={{ m: 1, width: 300 }}>
                  <InputLabel id="demo-multiple-chip-label">{getTranslation("User", preferredLanguage)}</InputLabel>
                  <Select
                    labelId="demo-multiple-chip-label"
                    id="demo-multiple-chip"
                    multiple
                    value={personName}
                    onChange={handleChange}
                    input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
                    renderValue={(selected) => (
                      <Box style={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {selected.map((value) => (
                          <Chip key={value} label={value} />
                        ))}
                      </Box>
                    )}
                    MenuProps={MenuProps}
                  >
                    {data &&
                      data?.users.map((user) => (
                        <MenuItem key={user.email} value={user.email} style={getStyles(user.email, personName, theme)}>
                          {user.email}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{getTranslation("Cancel", preferredLanguage)}</Button>
            <Button onClick={handleAssignCourse}>{getTranslation("Ok", preferredLanguage)}</Button>
          </DialogActions>
        </Dialog>
      </div>
      {/* <AssignTrainingTable props={props}/> */}
    </div>
  );
}
